import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13100846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center gutter-x-s5 xl:gutter-x-s4 justify-content-center sm:justify-content-end" }
const _hoisted_2 = ["href"]

import Icon from '@/components/icon/Icon.vue';
import { SOCIAL_LINKS } from '@/constants/EXTERNAL_LINKS';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommunityIcons',
  setup(__props) {

const socials = [
  {
    name: 'Twitter',
    link: SOCIAL_LINKS.TWITTER,
  },
  {
    name: 'Telegram',
    link: SOCIAL_LINKS.TELEGRAM,
  },
  {
    name: 'mail',
    link: SOCIAL_LINKS.MAIL,
  },
  {
    name: 'GitHub',
    link: SOCIAL_LINKS.GITHUB,
  },
  {
    name: 'Discord',
    link: SOCIAL_LINKS.DISCORD,
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socials, (item, index) => {
      return _createElementVNode("a", {
        key: 'social' + index,
        href: item.link,
        target: "_blank"
      }, [
        _createVNode(Icon, {
          name: item.name.toLowerCase(),
          size: "20",
          class: "social-icon m-s2"
        }, null, 8, ["name"])
      ], 8, _hoisted_2)
    }), 64))
  ]))
}
}

})